import { ProductVM } from '../common/view-model';

export const validateAllMetricsUnavailable = (product: ProductVM | undefined) => {
	const metrictsToValidate = ['dollars', 'productUnits', 'distribution', 'velocity'];
	return metrictsToValidate.every(metric => {
		const value = Object.entries(product?.spinsMetrics || []).find(([key]) => key === metric)?.[1];
		return value === null || value === undefined || value === 'N/A';
	});
};
